import { Container } from "react-bootstrap";
import PanssTest from "../components/PanssTest";
import { useTranslation } from "react-i18next";

function PredictPage() {
    const [t, i18n] = useTranslation("global");
    return (
        <>
            <Container>
                <h1 className="mt-5 mb-5">{t("predictions.title")}</h1>
                <PanssTest />
            </Container>
        </>
    );
}
export default PredictPage;
